/* eslint-disable */
import requestRaw from '@/utils/requestRaw'
import request from '@/utils/request'
import { APICore, APICoreV2 } from '@/utils/servicesApi'
const qs = require('qs')

export function getContactIdByGroup(data) {
  return requestRaw({
    url: APICore() + '/contact/get-contact-id-bygroup',
    method: 'POST',
    data: data // untuk array data post
  })
}


export function getContactIdByPhone(data) {
  return requestRaw({
    url: APICore() + '/contact/get-contact-id-byphone',
    method: 'POST',
    data: data // untuk array data post
  })
}

export function removeGroup(data) {
  return requestRaw({
    url: APICore() + '/contact/remove-group',
    method: 'POST',
    data: data // untuk array data post
  })
}
export function exportData(data) {
  return requestRaw({
    url: APICore() + '/contact/export',
    method: 'POST',
    data: data // untuk array data post
  })
}
export function unassignGroup(data) {
  return requestRaw({
    url: APICore() + '/contact/unassign-group',
    method: 'POST',
    data: data // untuk array data post
  })
}
export function unassignContactSelected(data) {
  return requestRaw({
    url: APICore() + '/contact/unassign-contact-selected',
    method: 'POST',
    data: data // untuk array data post
  })
}
export function addContactToList(data) {
  return requestRaw({
    url: APICore() + '/contact/add-contact-to-list',
    method: 'POST',
    data: data // untuk array data post
  })
}
export function removeAllContact() {
  return requestRaw({
    url: APICore() + '/contact/remove-all-contact',
    method: 'POST',
  })
}


export function deleteContactSelected(data) {
  return requestRaw({
    url: APICore() + '/contact/delete-contact-selected',
    method: 'POST',
    data: data // untuk array data post
  })
}

export function syncContactsCheck(data) {
  return request({
    url: APICoreV2() + '/contact/check-sync-contacts',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function syncContactsProcess(data) {
  return request({
    url: APICoreV2() + '/contact/sync-contacts',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function createGroup(data) {
  return requestRaw({
    url: APICore() + '/contact/create-group',
    method: 'POST',
    data: data // untuk array data post
  })
}

export function importContact(data) {
  return request({
    url: APICore() + '/contact/import-contact',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function viewContact(id) {
  return requestRaw({
    url: APICore() + '/contact/view-contact?id=' + id,
    method: 'GET',
  })
}

export function updateContact(data) {
  return requestRaw({
    url: APICore() + '/contact/update-contact',
    method: 'POST',
    data: data // untuk array data post
  })
}

export function createContact(data) {
  return requestRaw({
    url: APICore() + '/contact/create-contact',
    method: 'POST',
    data: data // untuk array data post
  })
}

export function getContactList(data) {
  return requestRaw({
    url: APICore() + '/contact/get-contact-list',
    method: 'POST',
    data: data // untuk array data post
  })
}

export function getContactListFromTags(data) {
  return requestRaw({
    url: APICore() + '/contact/get-contact-list-fromtags',
    method: 'POST',
    data: data // untuk array data post
  })
}

export function getGroupList(data) {
  return requestRaw({
    url: APICore() + '/contact/get-group-list',
    method: 'POST',
    data: data // untuk array data post
  })
}


// WEBPACK FOOTER //
// ./src/api/contact.js